/**
 * Dokumentstand einer Bestellung, wie der Server ihn rechnet - KEIN Teil der Portierung aus
 * `index.html` (dort rechnet `docProgress` im Browser), deshalb ein eigenes Modul und nicht
 * `lib/status.ts`: neue Exporte dort braeuchten eine Herkunftsmarke (`herkunft.test.ts`).
 *
 * Spec 2026-10-31-board-dokumentstand: das Backend bewertet die Dokumente-Checkliste (Drawer-Reiter
 * „Dokumente") und liefert das Ergebnis an jeder Hub-Bestellung als Lesefeld `dokumentStand`
 * (`GET /api/orders`, `GET /api/orders/:id` und die Antwort von `POST /api/orders`, die Anlage). Board-Gruppe „Abgeschlossen – Warten auf Dokumente",
 * Drawer-Banner „Bestellung vollstaendig" und die automatische Archivierung lesen NUR dieses Feld -
 * so urteilen sie wie die Checkliste („entfaellt" zaehlt, optionale Belege halten nicht auf, die
 * Bestell-Excel ist kein Pflichtbeleg), statt aus `pdfs[]` ein zweites Mal zu rechnen.
 *
 * Ein fehlendes oder unsinniges Feld (JTL-Bestellung ohne Hub-Zeile, Fehlformat) heisst „nicht
 * vollstaendig" und wirft nie: lieber eine Bestellung zu lange auf dem Board lassen, als sie
 * faelschlich zu archivieren.
 */
import type { DokumentStand, Order } from "./types.ts";

/** Gueltig = Objekt, beide Werte ganze Zahlen >= 0 und `pflichtOffen <= pflichtGesamt`. */
function gueltigerStand(wert: unknown): DokumentStand | null {
  if (typeof wert !== "object" || wert === null || Array.isArray(wert)) return null;
  const { pflichtGesamt, pflichtOffen } = wert as Record<string, unknown>;
  if (typeof pflichtGesamt !== "number" || !Number.isInteger(pflichtGesamt) || pflichtGesamt < 0) return null;
  if (typeof pflichtOffen !== "number" || !Number.isInteger(pflichtOffen) || pflichtOffen < 0) return null;
  if (pflichtOffen > pflichtGesamt) return null;
  return { pflichtGesamt, pflichtOffen };
}

/** `true` genau dann, wenn `o.dokumentStand` gueltig ist und kein Pflichtbeleg mehr offen ist. */
export function dokumenteVollstaendig(o: Order): boolean {
  const stand = gueltigerStand(o.dokumentStand);
  return stand !== null && stand.pflichtOffen === 0;
}

/** Erledigte von allen Pflichtbelegen; ohne gueltigen Stand `{ done: 0, total: 0 }`. */
export function dokumentQuote(o: Order): { done: number; total: number } {
  const stand = gueltigerStand(o.dokumentStand);
  if (stand === null) return { done: 0, total: 0 };
  return { done: stand.pflichtGesamt - stand.pflichtOffen, total: stand.pflichtGesamt };
}
